import { DataTable } from '@ztechapps/webui.data-tools'
import { useBlogListContext } from './Context'
import { ListViewRow } from './ListViewRow'
import { ListViewHeader } from './ListViewHeader'
import { blogListFieldConfig } from './constants'

const ListView = () => {
  const listResult = useBlogListContext()

  return (
    <DataTable
      name="blog_list_v1"
      listResult={listResult}
      fields={blogListFieldConfig}
      head={ListViewHeader}
      row={ListViewRow}
      tableOptions={{ responsive: true }}
    />
  )
}

export { ListView }
